export enum RequestType {
  DOWNLOAD = "DOWNLOAD",
  CORRECTION = "CORRECTION",
  PRE_RTC_DOWNLOAD = "PRE_RTC_DOWNLOAD",
  POST_RTC_VAL_DOWNLOAD = "POST_RTC_VAL_DOWNLOAD",
  DELETE = "DELETE",
}
